const VISITOR_ID_COOKIE = 'JobseekerVisitorId';
const SESSION_ID_COOKIE = 'JobseekerSessionId';
const VISITOR_ID_HEADER = 'X-Seek-EC-VisitorId';
const SESSION_ID_HEADER = 'X-Seek-EC-SessionId';

const cookieString = typeof document !== 'undefined' ? document.cookie : '';

export interface TrackingHeaders {
  [headerName: string]: string;
}
export default (cookies: string = cookieString): TrackingHeaders =>
  cookies
    .replace(VISITOR_ID_COOKIE, VISITOR_ID_HEADER)
    .replace(SESSION_ID_COOKIE, SESSION_ID_HEADER)
    .split(';')
    .filter(
      (value) =>
        value.indexOf(VISITOR_ID_HEADER) > -1 ||
        value.indexOf(SESSION_ID_HEADER) > -1,
    )
    .reduce((sum, cookie) => {
      const [key, value] = cookie.split('=');

      return {
        ...sum,
        [key.trim()]: value.trim(),
      };
    }, {});
